import { Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import './BookASection.scss'

const BookASection = () => {
  const navigate = useNavigate()
  const { t } = useTranslation(["translation", "de"])
  return (
    <Container fluid className="book-a-section">
      <Row className="book-a-section-body">
        <Col>
          <motion.h1
            className="book-a-section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {t('booking.title')}
          </motion.h1>
        </Col>
        <Col>
          <motion.span
            className="book-a-section-description"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            {t('booking.subtitle')}
          </motion.span>
        </Col>
        <Col className="d-flex justify-content-center pt-5">
          <motion.div
            className="book-a-section-button"
            onClick={() => navigate('contact-us')}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="book-a-section-button-text">{t('booking.button')}</span>
          </motion.div>
        </Col>
      </Row>

    </Container>
  )
}

export default BookASection
